import { setCookie } from 'src/misc/cookies';

export const setDarkModeCookie = (user: { dark_mode?: boolean }) => {
  if ('dark_mode' in user) {
    setCookie('dark_mode', String(user.dark_mode), 90000);
  }
};
